import LegalPage from '../components/LegalPage'

export default function RegulaminPage() {
  return (
    <LegalPage title="Regulamin usługi „Abonamenty Literackie”">
      <h2>§ 1. Postanowienia ogólne</h2>
      <p>
        Niniejszy Regulamin określa zasady korzystania z usługi subskrypcyjnej boxów książkowych,
        świadczonej przez sklep internetowy dostępny pod adresem abonamentyliterackie.pl oraz
        osobiście przez firmę pod spółką Światy Równoległe sp. z o.o. z siedzibą w Krakowie.
      </p>
      <p>
        Właścicielem sklepu i Usługodawcą jest firma pod spółką Światy Równoległe sp. z o.o. z
        siedzibą przy ul. Walerego Sławka 20/12, 30-633 w Krakowie; NIP: 6793371934; REGON:
        545321425; KRS: 0001255247 (dalej: „Usługodawca”). Kontakt z Usługodawcą jest możliwy pod
        adresem e-mail: michal@abonamentyliterackie.pl.
      </p>
      <p>
        Klientem (Subskrybentem) może być osoba fizyczna posiadająca pełną zdolność do czynności
        prawnych (w tym Konsument) lub przedsiębiorca.
      </p>

      <h2>§ 2. Opis usługi subskrypcji</h2>
      <p>
        Usługa polega na cyklicznym (co miesiąc) przygotowywaniu i dostarczaniu Subskrybentowi
        przesyłki (Boxu Książkowego) zawierającej książki oraz opcjonalne dodatki.
      </p>
      <p>Istnieją dwie formy Usługi:</p>
      <ul>
        <li>
          <strong>Usługa/subskrypcja odnawialna.</strong> Subskrypcja ta ma charakter ciągły i
          odnawia się automatycznie na kolejny okres rozliczeniowy (miesiąc), chyba że Subskrybent
          rezygnuje z usługi zgodnie z § 5 niniejszego Regulaminu.
        </li>
        <li>
          <strong>Usługa/subskrypcja przedpłacona (prezentowa).</strong> Subskrypcja ta wykupywana
          jest na konkretną liczbę miesięcy (3, 6 lub 12) i jest płatna z góry.
        </li>
      </ul>
      <p>
        Usługa może mieć charakter spersonalizowany (dalej: „abonament personalny”) lub nie (dalej:
        „abonament tematyczny”).
      </p>
      <p>
        Podczas składania zamówienia na abonament personalny Subskrybent może dobrowolnie uzupełnić
        profil preferencji literackich. Usługodawca dokłada starań, aby zawartość boxu była
        dopasowana do wskazanych preferencji. Ostateczny dobór tytułów pozostaje decyzją
        Usługodawcy.
      </p>
      <p>
        Usługodawca nie ma obowiązku informowania Subskrybenta o zawartości Boxu Książkowego na
        dany miesiąc przed faktyczną wysyłką Boxu.
      </p>

      <h2>§ 3. Płatności cykliczne (subskrypcyjne)</h2>
      <p>
        Cena za pojedynczy Box Książkowy określona jest przez typ i charakter subskrypcji. W
        przypadku subskrypcji odnawialnej koszt dostawy wynosi 15 złotych za każdomiesięczną
        przesyłkę. W przypadku subskrypcji prezentowej koszt dostawy wliczony jest w jednorazowy
        koszt subskrypcji.
      </p>
      <p>
        Usługa odnawialna wymaga uruchomienia płatności cyklicznych (automatyczne obciążanie karty
        płatniczej Subskrybenta za pośrednictwem operatora płatności).
      </p>
      <p>
        Pierwsza opłata za usługę odnawialną i jej wysyłkę pobierana jest w dniu zakupu subskrypcji.
        Kolejne opłaty będą pobierane automatycznie tego samego dnia każdego kolejnego miesiąca (np.
        każdego 10. dnia miesiąca).
      </p>
      <p>
        W przypadku braku środków na karcie lub wygaśnięcia ważności karty, Usługodawca będzie
        podejmował ponowne próby obciążenia konta przez okres 7 dni. Jeśli próby się nie powiodą,
        subskrypcja zostanie zawieszona, a box nie zostanie wysłany. Subskrybent zostanie
        powiadomiony o zawieszeniu subskrypcji.
      </p>
      <p>
        Płatność za usługę prezentową jest jednorazowa i nie wymaga uruchomienia płatności
        cyklicznych.
      </p>

      <h2>§ 4. Realizacja i dostawa</h2>
      <p>
        Wysyłka Boxów Książkowych odbywa się w cyklach miesięcznych, w terminie do 30 dni od daty
        zaksięgowania płatności za dany miesiąc (w przypadku subskrypcji odnawialnych) lub od daty
        ostatniej przesyłki (w przypadku subskrypcji prezentowych).
      </p>
      <p>Pierwsza dostawa następuje w terminie do 30 dni od dnia aktywacji subskrypcji, gdzie datę aktywacji stanowi:</p>
      <ul>
        <li>
          w przypadku abonamentów tematycznych w usłudze odnawialnej: dzień zaksięgowania pierwszej
          płatności;
        </li>
        <li>
          w przypadku abonamentów personalnych w usłudze odnawialnej: dzień zatwierdzenia formularza
          z indywidualnymi preferencjami literackimi;
        </li>
        <li>
          w przypadku abonamentów w usłudze prezentowej: dzień połączenia abonamentu z kontem
          klienta poprzez wprowadzenie indywidualnego kodu abonamentu. Konto klienta, z którym
          połączony został abonament, staje się kontem Subskrybenta.
        </li>
      </ul>
      <p>
        Dostawa realizowana jest na adres wskazany przez Subskrybenta podczas rejestracji lub
        zmodyfikowany w Panelu Klienta przed rozpoczęciem nowego cyklu wysyłkowego.
      </p>
      <p>
        Zmiana adresu dostawy na dany miesiąc musi nastąpić najpóźniej do dnia zaksięgowania płatności
        za dany miesiąc. Zmiany dokonane po tym terminie będą obowiązywały od kolejnego miesiąca.
      </p>

      <h2>§ 5. Anulowanie i zawieszenie subskrypcji</h2>
      <p>
        Subskrybent ma prawo zrezygnować z subskrypcji odnawialnej w dowolnym momencie, bez ponoszenia
        dodatkowych kosztów.
      </p>
      <p>
        Rezygnacji można dokonać bezpośrednio w Panelu Klienta poprzez kliknięcie opcji „Anuluj
        subskrypcję”.
      </p>
      <p>
        Aby anulowanie odniosło skutek przed kolejnym okresem rozliczeniowym, należy dokonać go
        najpóźniej na XXX przed planowanym terminem pobrania kolejnej opłaty. W przeciwnym razie
        opłata zostanie pobrana, a klient otrzyma ostatni, opłacony Box.
      </p>
      <p>
        W przypadku rezygnacji z subskrypcji prezentowej Subskrybentowi nie przysługuje zwrot środków
        za nieotrzymane Boxy.
      </p>

      <h2>§ 6. Odstąpienie od umowy, zwroty i wymiany</h2>
      <p>
        Subskrybent będący Konsumentem ma prawo odstąpić od umowy w terminie 14 dni od dnia
        otrzymania pierwszego Boxu Książkowego, bez podania przyczyny.
      </p>
      <p>
        Ze względu na charakter usługi cyklicznej, zwrotowi podlega wyłącznie Box nienaruszony
        (książki nie mogą nosić śladów użytkowania, folie ochronne – jeśli były – muszą pozostać
        nienaruszone).
      </p>
      <p>Koszt odesłania zwracanego Boxu ponosi Subskrybent.</p>
      <p>
        Subskrybent może odesłać Box Książkowy na zasadach opisanych w § 6.2-3 w terminie do 7 dni
        od jego otrzymania, jeśli jako przyczynę poda fakt posiadania już książki będącej główną
        składową Boxu. Usługodawca zobowiązuje się wysłać takiemu Subskrybentowi inną książkę zgodną
        z zasadami Usługi w terminie 30 dni od daty zwrotu. Ponowna wysyłka może zostać połączona z
        wysyłką kolejnego Boxu w cyklu miesięcznym.
      </p>

      <h2>§ 7. Reklamacje</h2>
      <p>
        Jeżeli dostarczony produkt jest wadliwy (np. uszkodzona książka w transporcie), Subskrybent
        ma prawo złożyć reklamację.
      </p>
      <p>
        Reklamacje należy zgłaszać drogą mailową na adres michal@abonamentyliterackie.pl, dołączając
        opis wady oraz, w miarę możliwości, zdjęcia uszkodzenia.
      </p>
      <p>
        Usługodawca rozpatrzy reklamację w terminie 14 dni od jej otrzymania i poinformuje klienta o
        sposobie jej rozwiązania (np. wymiana książki na zasadach opisanych w § 6.4, rabat na
        usługę).
      </p>

      <h2>§ 8. Ochrona danych osobowych</h2>
      <p>Administratorem danych osobowych Subskrybentów jest Usługodawca.</p>
      <p>
        Dane adresowe przetwarzane są w celu realizacji umowy (art. 6 ust. 1 lit. b RODO), a
        dobrowolnie podane preferencje czytelnicze na podstawie zgody (art. 6 ust. 1 lit. a RODO) lub
        w celu optymalnego wykonania umowy – zgodnie z Polityką Prywatności sklepu.
      </p>
    </LegalPage>
  )
}
